import { render } from "./list.vue?vue&type=template&id=11bd752e&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=11bd752e&scoped=true&lang=scss"

import exportComponent from "D:\\GitLocal\\mvs-sys\\mvsui-user\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11bd752e"]])

export default __exports__